import React from 'react';
import { Link } from '@inertiajs/react';
import { cn } from '../utils/cn';
import { Button } from './Button';
export const FormActions = React.forwardRef(function FormActions(
  {
    submitLabel = 'Save',
    cancelLabel = 'Cancel',
    cancelHref,
    onCancel,
    processing = false,
    className,
  },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'flex items-center justify-end gap-3 border-t border-edge-strong pt-6',
        className,
      )}
    >
      {(cancelHref || onCancel) &&
        (cancelHref ? (
          <Link
            href={cancelHref}
            className="text-sm font-medium text-fg-secondary hover:text-fg transition-colors"
          >
            {cancelLabel}
          </Link>
        ) : (
          <button
            type="button"
            onClick={onCancel}
            className="text-sm font-medium text-fg-secondary hover:text-fg transition-colors"
          >
            {cancelLabel}
          </button>
        ))}
      <Button type="submit" loading={processing}>
        {submitLabel}
      </Button>
    </div>
  );
});
